// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-container {
  margin: 50px auto;
  width: 280px;
  text-align: center;
  background-color: #f2f2f2;
}
.switch-container > .switch {
  display: block;
  margin: 22px auto;
}

.switch {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 106px;
  height: 36px;
  padding: 1px;
  border-radius: 7px;
  cursor: pointer;
}

.switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 10px;
  text-transform: uppercase;
  border-radius: inherit;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12),
    inset 0 0 2px rgba(0, 0, 0, 0.15);
  transition: 0.15s ease-out;
  transition-property: opacity background;
}
.switch-label:before,
.switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -0.5em;
  line-height: 1;
  transition: inherit;
}
.switch-label:before {
  content: attr(data-off);
  right: 11px;
  top: 14px;
  width: 32px;
  text-align: center;
  color: #aaa;
  text-shadow: 0 1px rgba(255, 255, 255, 0.5);
  font-weight: 800;
}
.switch-label:after {
  content: attr(data-on);
  left: 8px;
  top: 14px;
  width: 36px;
  text-align: center;
  color: #aaa;
  text-shadow: 0 1px rgba(255, 255, 255, 0.5);
  opacity: 0;
  font-weight: 800;
}
.switch-input:checked ~ .switch-label {
  background: #e57061;
}
.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}
.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}

.colors-white {
  color: white;
}

.switch-handle {
  position: absolute;
  top: 3px;
  left: 5px;
  width: 50px;
  height: 31px;
  background: white;
  border-radius: 6px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
  transition: left 0.15s ease-out;
}
.switch-handle:before {
  content: "";
  position: inherit;
  display: flex;
  margin: -6px 0 0 -6px;
  width: 12px;
  height: 12px;
  background: #f9f9f9;
  border-radius: 6px;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: space-between;
  align-items: center;
}
.switch-input:checked ~ .switch-handle {
  left: 50px;
  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
  background-color: #db0b27;
}

.switch-input:checked ~ .switch-handle:before {
  content: "KM ON";
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  margin-left: 1.7em;
  text-align: center;
  line-height: 90%;
  margin-top: 0.6em;
}

.switch-input ~ .switch-handle:before {
  content: "KM OFF";
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  margin-left: 1.7em;
  text-align: center;
  line-height: 90%;
  margin-top: 0.6em;
}

.switch-input ~ .switch-handle {
  background-color: #db0b27;
}

.switch-input ~ .switch-handle:before {
  background-color: #db0b27;
}

.switch-checked > .switch-input:checked ~ .switch-label {
  background: #fff;
}

.container.disabled {
  opacity: 0.5;
  pointer-events: none;
  background-color: green;
  /* Otros estilos deshabilitados */
}

.container.disabled .switch-label {
  cursor: not-allowed;
  /* Otros estilos para el label deshabilitado */
}

.container.disabled .switch-handle {
  background-color: blue;
  /* Otros estilos para el handle deshabilitado */
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/SwitchControlKm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB;qCACmC;EAInC,0BAA0B;EAI1B,uCAAuC;AACzC;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EAId,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAI1C,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;AACjD","sourcesContent":[".switch-container {\n  margin: 50px auto;\n  width: 280px;\n  text-align: center;\n  background-color: #f2f2f2;\n}\n.switch-container > .switch {\n  display: block;\n  margin: 22px auto;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 106px;\n  height: 36px;\n  padding: 1px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n\n.switch-input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n.switch-label {\n  position: relative;\n  display: block;\n  height: inherit;\n  font-size: 10px;\n  text-transform: uppercase;\n  border-radius: inherit;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12),\n    inset 0 0 2px rgba(0, 0, 0, 0.15);\n  -webkit-transition: 0.15s ease-out;\n  -moz-transition: 0.15s ease-out;\n  -o-transition: 0.15s ease-out;\n  transition: 0.15s ease-out;\n  -webkit-transition-property: opacity background;\n  -moz-transition-property: opacity background;\n  -o-transition-property: opacity background;\n  transition-property: opacity background;\n}\n.switch-label:before,\n.switch-label:after {\n  position: absolute;\n  top: 50%;\n  margin-top: -0.5em;\n  line-height: 1;\n  -webkit-transition: inherit;\n  -moz-transition: inherit;\n  -o-transition: inherit;\n  transition: inherit;\n}\n.switch-label:before {\n  content: attr(data-off);\n  right: 11px;\n  top: 14px;\n  width: 32px;\n  text-align: center;\n  color: #aaa;\n  text-shadow: 0 1px rgba(255, 255, 255, 0.5);\n  font-weight: 800;\n}\n.switch-label:after {\n  content: attr(data-on);\n  left: 8px;\n  top: 14px;\n  width: 36px;\n  text-align: center;\n  color: #aaa;\n  text-shadow: 0 1px rgba(255, 255, 255, 0.5);\n  opacity: 0;\n  font-weight: 800;\n}\n.switch-input:checked ~ .switch-label {\n  background: #e57061;\n}\n.switch-input:checked ~ .switch-label:before {\n  opacity: 0;\n}\n.switch-input:checked ~ .switch-label:after {\n  opacity: 1;\n}\n\n.colors-white {\n  color: white;\n}\n\n.switch-handle {\n  position: absolute;\n  top: 3px;\n  left: 5px;\n  width: 50px;\n  height: 31px;\n  background: white;\n  border-radius: 6px;\n  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);\n  -webkit-transition: left 0.15s ease-out;\n  -moz-transition: left 0.15s ease-out;\n  -o-transition: left 0.15s ease-out;\n  transition: left 0.15s ease-out;\n}\n.switch-handle:before {\n  content: \"\";\n  position: inherit;\n  display: flex;\n  margin: -6px 0 0 -6px;\n  width: 12px;\n  height: 12px;\n  background: #f9f9f9;\n  border-radius: 6px;\n  box-shadow: inset 0 1px rgba(0, 0, 0, 0.02);\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-content: space-between;\n  align-items: center;\n}\n.switch-input:checked ~ .switch-handle {\n  left: 50px;\n  box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);\n  background-color: #db0b27;\n}\n\n.switch-input:checked ~ .switch-handle:before {\n  content: \"KM ON\";\n  color: #fff;\n  font-size: 11px;\n  font-weight: 900;\n  margin-left: 1.7em;\n  text-align: center;\n  line-height: 90%;\n  margin-top: 0.6em;\n}\n\n.switch-input ~ .switch-handle:before {\n  content: \"KM OFF\";\n  color: #fff;\n  font-size: 11px;\n  font-weight: 900;\n  margin-left: 1.7em;\n  text-align: center;\n  line-height: 90%;\n  margin-top: 0.6em;\n}\n\n.switch-input ~ .switch-handle {\n  background-color: #db0b27;\n}\n\n.switch-input ~ .switch-handle:before {\n  background-color: #db0b27;\n}\n\n.switch-checked > .switch-input:checked ~ .switch-label {\n  background: #fff;\n}\n\n.container.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  background-color: green;\n  /* Otros estilos deshabilitados */\n}\n\n.container.disabled .switch-label {\n  cursor: not-allowed;\n  /* Otros estilos para el label deshabilitado */\n}\n\n.container.disabled .switch-handle {\n  background-color: blue;\n  /* Otros estilos para el handle deshabilitado */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
